/* YIOSI shared behaviours — reveal-on-scroll */
(function(){
  document.documentElement.classList.add('yiosi-js');
  function init(){
    var els = document.querySelectorAll('.reveal:not(.in)');
    if(!('IntersectionObserver' in window)){ els.forEach(function(el){el.classList.add('in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    },{ rootMargin:'0px 0px -8% 0px', threshold:.08 });
    els.forEach(function(el){ io.observe(el); });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();


/* YIOSI shared behaviours — mouse drag-to-scroll for mobile carousels */
(function(){
  var SEL = '.look-grid,.rev-cards,.hs-grid,.rel-grid,.rv-grid,.mat-grid,.episodes,.assure-grid';
  function arm(el){
    if(el.dataset.yiosiDrag) return;
    el.dataset.yiosiDrag = '1';
    var startX = 0, startLeft = 0, dragging = false, moved = false;
    el.addEventListener('pointerdown', function(e){
      if(e.pointerType !== 'mouse' || e.button !== 0) return;
      if(el.scrollWidth <= el.clientWidth + 4) return;
      dragging = true; moved = false;
      startX = e.clientX; startLeft = el.scrollLeft;
      el.classList.add('yiosi-dragging');
      try{ el.setPointerCapture(e.pointerId); }catch(_){}
    });
    el.addEventListener('pointermove', function(e){
      if(!dragging) return;
      var dx = e.clientX - startX;
      if(Math.abs(dx) > 5) moved = true;
      el.scrollLeft = startLeft - dx;
      if(moved) e.preventDefault();
    });
    function end(e){
      if(!dragging) return;
      dragging = false;
      el.classList.remove('yiosi-dragging');
      try{ el.releasePointerCapture(e.pointerId); }catch(_){}
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    el.addEventListener('dragstart', function(e){ e.preventDefault(); });
  }
  function init(){ document.querySelectorAll(SEL).forEach(arm); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
